<script setup>
import AppButton from '@Components/Button.vue'
import { useForm, usePage } from '@inertiajs/inertia-vue3';
import { computed } from 'vue'

const pageData = computed(() => {
    return usePage().props.value
})

const userData = computed(() => {
    return _.get(pageData.value, 'auth.user', false)
})

const impersonator = computed(() => {
    return _.get(pageData.value, 'impersonator', false)
})

const form = useForm({})

function handleAction(){
    const ask = confirm('Are you sure to stop impersonation?')

    if (ask) {
        form.post('/actions/stop-impersonation')
    }
}
</script>

<template>
    <div v-if="impersonator" class="px-5 py-4 bg-primary drop-shadow-md">
        <div class="flex items-center justify-between space-x-4">
            <div class="flex-1 min-w-0">
                <div class="font-medium">You're currently impersonating as {{ userData?.first_name }} {{ userData?.last_name }}</div>
            </div>
            <div class="flex-shrink-0">
                <app-button @click="handleAction" :busy="form.processing" class="!text-white !bg-secondary hover:!opacity-80">Stop Impersonation</app-button>
            </div>
        </div>
    </div>
</template>
